webpackJsonp([41],{

/***/ "27+N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _ContentWrapper = __webpack_require__("yfaX");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Imprint = function Imprint() {
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            _reactHelmet.Helmet,
            null,
            _react2.default.createElement('meta', { name: 'robots', content: 'noindex, nofollow' })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'article',
                {
                    about: '/legal/imprint',
                    'typeof': 'schema:WebPage'
                },
                _react2.default.createElement(
                    _ContentWrapper2.default,
                    null,
                    _react2.default.createElement('span', {
                        property: 'schema:name',
                        content: 'Imprint',
                        className: 'stolo-hidden'
                    }),
                    _react2.default.createElement(
                        'div',
                        {
                            property: 'schema:text',
                            className: 'clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item'
                        },
                        _react2.default.createElement(
                            'h2',
                            null,
                            'Imprint'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Becker & Karsten UG (haftungsbeschr\xE4nkt)',
                            _react2.default.createElement('br', null),
                            'Sandhauser Strasse 107',
                            _react2.default.createElement('br', null),
                            '13505 Berlin',
                            _react2.default.createElement('br', null),
                            '(not a retail store)',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto: wir@stoff.love' },
                                'wir@stoff.love'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Phone: +49 30 609851965',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'represented by:',
                            _react2.default.createElement('br', null),
                            'Olaf Karsten (Managing Director)',
                            _react2.default.createElement('br', null),
                            'Sandhauser Strasse 107',
                            _react2.default.createElement('br', null),
                            '13505 Berlin',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto: wir@stoff.love' },
                                'wir@stoff.love'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Phone: (030) 609851965'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            'Responsible for data protection:',
                            _react2.default.createElement('br', null),
                            'Olaf Karsten',
                            _react2.default.createElement('br', null),
                            'Address as above',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Email:',
                            ' ',
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'buk-mail',
                                    href: 'mailto:datenschutz@beckerundkarsten.de'
                                },
                                'datenschutz@beckerundkarsten.de'
                            )
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: '/legal/privacy' },
                                'Our privacy policy.'
                            )
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            'Email:\xA0',
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto: wir@stoff.love' },
                                'wir@stoff.love'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Registry court: Berlin Charlottenburg',
                            _react2.default.createElement('br', null),
                            'Registration number: HRB 120030',
                            _react2.default.createElement('br', null),
                            'VAT identification number pursuant to \xA727a Umsatzsteuergesetz:',
                            _react2.default.createElement('br', null),
                            'VAT ID: DE265138737',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Responsible party within the meaning of \xA7 18 Abs. 2 MStV:',
                            _react2.default.createElement('br', null),
                            'Olaf Karsten, Standhauser Str. 107, 13505 Berlin',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Competent supervisory authority for the provision of audiovisual media services:',
                            _react2.default.createElement('br', null),
                            'Medienanstalt Berlin-Brandenburg (mabb), Kleine Pr\xE4sidentenstra\xDFe 1, 10178 Berlin, Germany',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null)
                        )
                    )
                )
            )
        )
    );
};

exports.default = Imprint;

/***/ }),

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "yfaX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__("L4iW");

var _Paper2 = _interopRequireDefault(_Paper);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = (0, _styledComponents2.default)(_Paper2.default).withConfig({
  displayName: 'ContentWrapper',
  componentId: 'sc-1b74oo9-0'
})(['\n  margin: ', ' 0;\n  padding: ', ';\n  position: relative;\n    \n    & p {\n      line-height: 1.61em;\n      margin-bottom: ', ';\n      max-width: ', ';\n    }\n\n    & h1, h2, h3, h4, h5, h6 {\n      margin: ', ' 0 ', ';\n    }\n    \n    & img {\n      max-width: 100%;\n    }\n\n'], function (props) {
  return props.theme.space[12];
}, function (props) {
  return props.theme.space[10];
}, function (props) {
  return props.theme.space[9];
}, function (props) {
  return props.theme.space[23];
}, function (props) {
  return props.theme.space[7];
}, function (props) {
  return props.theme.space[12];
});

exports.default = ContentWrapper;

/***/ }),

/***/ "yqnL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Imprint = __webpack_require__("27+N");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Imprint).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

});


// WEBPACK FOOTER //
// async/enImprint.a82c205591520926bc68.js